export default __webpack_public_path__ + "static/media/img14.a9e87bae.JPG";